/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { LogoPartner } from '../LogoPartner';
import './style.css';

export const LogosSocialMediaPlatforms = ({
    breakpoint,
    color,
    className,
    logoPartnerBundesministerium = '/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg',
}) => {
    return (
        <div
            className={`logos-partners-group color-5-${color} breakpoint-0-${breakpoint} ${className}`}
        >
            {/* Sorry Elon, it's getting too weird
		<div style={{cursor: "pointer"}} onClick={()=>{
			window.open("https://x.com/tuecede", '_blank').focus();
		}}><img style={{"width": "20px"}} src="/img/social_media_logos/x_logo-white.png"/></div>
		*/}
            <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    window
                        .open('https://www.instagram.com/tuecede/', '_blank')
                        .focus();
                }}
            >
                <img
                    style={{ width: '20px' }}
                    src="/img/social_media_logos/Instagram_Glyph_White.png"
                />
            </div>
            <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    window
                        .open(
                            'https://www.youtube.com/channel/UC6A-9rKF5vArkzEjNRaqgkw',
                            '_blank',
                        )
                        .focus();
                }}
            >
                <img
                    style={{ width: '20px' }}
                    src="/img/social_media_logos/yt_icon_mono_dark.png"
                />
            </div>
        </div>
    );
};

LogosSocialMediaPlatforms.propTypes = {
    breakpoint: PropTypes.oneOf(['desktop', 'mobile']),
    color: PropTypes.oneOf(['white', 'default']),
    logoPartnerBundesministerium: PropTypes.string,
};
